import {
  GET_WIDGETS_FOR_OVERALL_TAB,
  GET_WIDGETS_FOR_MY_DASHBOARD_TAB,
  GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB,
  GET_WIDGETS_FOR_USER_PERFORMANCE_TAB,
  GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB,
} from "../constants";
import { ApiCall } from "../../utils/index";

export const getOverallTabWidgets =
  (from_date, to_date) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let params;
      let url = "/analytics/overall";

      if (from_date && to_date) {
        params = `?from_date=${from_date}&to_date=${to_date}`;
        url += params;
        console.log("url ---", url);
      }

      const result = await ApiCall.get(url, token);
      dispatch({ type: GET_WIDGETS_FOR_OVERALL_TAB, payload: result.data });
    } catch (error) {
      console.log("error ----", error);
    }
  };

export const getMyDashboardTabWidgets =
  (from_date, to_date) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let params;
      let url = "/analytics/dashboard";

      if (from_date && to_date) {
        params = `?from_date=${from_date}&to_date=${to_date}`;
        url += params;
      }

      const result = await ApiCall.get(url, token);
      dispatch({
        type: GET_WIDGETS_FOR_MY_DASHBOARD_TAB,
        payload: result.data,
      });
    } catch (error) {
      console.log("error ---", error);
    }
  };

export const addToMyDashboard = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      "/analytics/dashboard",
      request.payload,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const deleteWidgets = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(
      `/analytics/dashboard/${request.dashboard_widget_id}`,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

export const getCollaboratorPerformanceTabWidgets =
  (start_date, end_date, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let url = "/analytics/collaborator";
      let params;

      if (request?.id) {
        params = `?id=${request.id}`;
      }

      if (start_date && end_date) {
        params = request?.id
          ? `${params}&from_date=${start_date}&to_date=${end_date}`
          : `?from_date=${start_date}&to_date=${end_date}`;
      }

      if (params) {
        url += params;
      }

      const result = await ApiCall.get(url, token);
      dispatch({
        type: GET_WIDGETS_FOR_COLLABORATOR_PERFORMANCE_TAB,
        payload: result.data,
      });

    } catch (error) {
      request.onError(error);
    }
  };

export const userPerformanceTabWidgets =
  (start_date, end_date, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let url = "/analytics/user";
      let params;

      if (request?.id) {
        params = `?user_id=${request.id}`;
      }

      if (start_date && end_date) {
        params = request?.id
          ? `${params}&from_date=${start_date}&to_date=${end_date}`
          : `?from_date=${start_date}&to_date=${end_date}`;
      }

      if (params) {
        url += params;
      }

      const result = await ApiCall.get(url, token);
      dispatch({
        type: GET_WIDGETS_FOR_USER_PERFORMANCE_TAB,
        payload: result.data,
      });
     
    } catch (error) {
      request.onError(error);
    }
  };

  export const customerAnalysisTabWidgets =
  (start_date, end_date, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      let url = "/analytics/customer";
      let params;

      if (request?.id) {
        params = `?id=${request.id}`;
      }

      if (start_date && end_date) {
        params = request?.id
          ? `${params}&from_date=${start_date}&to_date=${end_date}`
          : `?from_date=${start_date}&to_date=${end_date}`;
      }

      if (params) {
        url += params;
      }

      const result = await ApiCall.get(url, token);
      dispatch({
        type: GET_WIDGETS_FOR_CUSTOMER_ANALYSIS_TAB,
        payload: result.data,
      });
     
    } catch (error) {
      request.onError(error);
    }
  };